/* eslint-disable no-unused-vars,no-unexpected-multiline */
import recordAudio from "./record-audio";
import uiControl from "./ui-control.js";
import cloneDeep from "lodash/cloneDeep";
import IMClientCallback from './imclient-callback'

import Vue from 'vue';
import {sharedServicesMgr, systemInfo} from "@/shared-services";

import IM from './im'
import single from './single'
import teams from './teams'

const filterRemove = (data) => {
  const str = data?.content ? JSON.parse(data?.content) : ''
  const extra = str?.extra ? JSON.parse(str?.extra) : ''
  return data.type == 'custom' && (extra.content.includes('removed') || extra.content.includes('invited') || extra.content.includes('has been removed') || extra.content.includes('quit')) ? true : false
}

const checkArray = (arr1, arr2) => {
  let newArr = []
  arr2.forEach(item => {
   arr1.forEach(x => {
     if(item.tid == x.to) {
       newArr.push(x)
     }
   })
  })
  return newArr
}

const getSingleName = (singleMap, id) => {
  return singleMap[id].clientUserName || singleMap[id].email
}


function initStore(store) {
  const state = {
    namespaced: true,
    state: {
      ...recordAudio.state,
      ...uiControl.state,
      ...single.state,
      ...teams.state,
      author: null,
      sessionList: [],
      currentSession: null,
      loadingMessage: {},
      initLoading: true,
      unsendMsgs: {},
      msgMap: {},
      unsendCountdownInfo: {},
      customMsgs: {},
      dragChatbox: {
        show: true,
        drag: true,
        bottom: 10,
        right: 10,
      },
      isTurnOnAudioList: []
    },
    mutations: {
      ...recordAudio.mutations,
      ...uiControl.mutations,
      ...single.mutations,
      ...teams.mutations,
      SET_INITLOADING(state, data) {
        state.initLoading = data
      },
      SET_PREVINITTIME(state, data) {
        state.prevInitTime = data;
      },
      SET_AUTHOR(state, accId) {
        state.author = accId
      },
      SET_SESSIONS(state, data) {
        state.sessionList = data;
      },
      SET_CURRENTSESSION(state, id) {
        state.currentSession = id
      },
      SET_UNSENDMSGS(state, data) {
        state.unsendMsgs = cloneDeep(data);
      },
      SET_COUNTDOWN(state, data) {
        if (!state.unsendCountdownInfo[data.to]) {
          state.unsendCountdownInfo[data.to] = {}
        }
        state.unsendCountdownInfo[data.to][data.createtime] = data.countdown
      },
      SET_COUNTDOWNREMOVE(state, data) {
        clearTimeout((state.unsendCountdownInfo[data.to] || {})[data.createtime])
        if (state.unsendCountdownInfo[data.to]) {
          delete state.unsendCountdownInfo[data.to][data.createtime]
        }
      },
      SET_LOADINGMSG(state, info) {
        let obj = {}
        obj[info.to] = info.loading
        state.loadingMessage = { ...state.loadingMessage, ...obj }
      },
      SET_MSGMAP(state, msgMap) {
        let obj = {}
        Object.keys(msgMap).forEach(to => {
          const msgs = msgMap[to]
          obj[to] = msgs.map(i => ({
            ...i,
            custom: i.custom && JSON.parse(i.custom)
          }))
        })
        state.msgMap = obj
      },
      SET_CUSTOM_MSGS(state, data) {
        state.customMsgs = data;
      },
      SET_DRAGCHATBOX(state, data) {
        let obj = Object.assign({}, state.dragChatbox, {
          drag: data.drag,
          show: data.show,
        });
        if (data.bottom === undefined && data.top === undefined) {
          obj.bottom = 10;
        } else {
          data.bottom
            ? (obj.bottom = data.bottom)
            : data.top
            ? (obj.top = data.top)
            : "";
        }
        if (data.left === undefined && data.right === undefined) {
          obj.right = 10;
        } else {
          data.right
            ? (obj.right = data.right)
            : data.left
            ? (obj.left = data.left)
            : "";
        }
        state.dragChatbox = obj;
      },
      SET_ALLAUDIO(state, data) {
        state.isTurnOnAudioList = [data]
      }
    },
    actions: {
      ...recordAudio.actions,
      ...uiControl.actions,
      ...single.actions,
      ...teams.actions,
      initIMToken({ state, dispatch, commit }, _) {
        if (state.prevInitTime && Date.now() - state.prevInitTime < 1000) return;
        commit('SET_PREVINITTIME', Date.now());
        this.prevInitTime = Date.now();
        if ((systemInfo.isCommand && localStorage.getItem('TP_PORTAL_TOKEN_V2')) || systemInfo.isDispatch) {
          try {
            IMClientCallback(store)
          } catch (error) {
            console.error(error);
          }
        } else {
          dispatch('initIMToken', _);
        }
      },
      setCurrentSession({ commit, getters, dispatch }, id = null) {
        if (!id) {
          commit('SET_CURRENTSESSION', null)
          return
        } else if (id === 'SYSTEM') {
          dispatch('dataCenter/readNotification', {}, {root: true});
          commit('SET_CURRENTSESSION', id)
          return
        }
        IM.getInstance().getHistoryMsgs(id)
        const session = getters.sessionsMap[id] || {}
        if (session.id) IM.getInstance().resetSessionUnread(session.id);
        if (getters.teamsMap[id] && !getters.teamsMap[id].teamMembers) {
          IM.getInstance().getTeamDetail(id)
        }
        commit('SET_CURRENTSESSION', id)
      },
      sendTextMsg({ state, commit, dispatch }, options) {
        const to = options.to
        IM.getInstance().sendMsg(options);
        let unsend = cloneDeep(state.unsendMsgs)
        let unsendItem = {
          ...options,
          type: 'text',
          status: 'sending',
          flow: 'out',
          unsend: true,
          time: options.createtime,
        }
        unsend[to] = unsend[to] ? [...cloneDeep(unsend[to]), unsendItem] : [unsendItem]
        commit('SET_UNSENDMSGS', unsend)
        dispatch('unsendCountdown', {
          unsendInfo: unsendItem,
          to
        })
      },
      sendImageMsg({ state, commit, dispatch }, options) {
        IM.getInstance().sendMsg(options, 'image')
        const to = options.to;
        let unsend = cloneDeep(state.unsendMsgs)
        let unsendItem = {
          ...options,
          type: 'image',
          unsend: true,
          flow: 'out',
          status: 'sending',
          time: options.createtime,
        }
        unsend[to] = unsend[to] ? [...cloneDeep(unsend[to]), unsendItem] : [unsendItem]
        commit('SET_UNSENDMSGS', unsend)
        dispatch('unsendCountdown', {
          unsendInfo: unsendItem,
          to
        })
      },
      // 发送自定义消息
      sendCustomMsg({ state, commit, rootState, dispatch }, { options, sendData, tripId, loadId }) {
        let obj = { 
          distance: sendData.distance,
          drivingTimeHours: sendData.drivingTimeHours,
          drivingTimeMinutes: sendData.drivingTimeMinutes,
          waypointList: [
            { title: sendData.waypointList[0].title },
            {
              title:
                sendData.waypointList[sendData.waypointList.length - 1].title,
            },
          ],
        };
        let stopsLength = sendData.waypointList.filter(item => !item.hidden).length - 2;
        let content = {
          type: 7,
          root: "1",
          data: {
            id: options.AppId,
            webId: options.addId,
            stops: stopsLength,
            sendData: obj,
            tripId: tripId || null,
            loadId: loadId || null
          },
        };
        commit("SET_CUSTOM_MSGS", content);
        let singleFind = state.singleList.find(item => item.accId === options.to)
        if (!singleFind) return;
        const t = Date.now();
        let extra = cloneDeep(state.customMsgs)
        extra = {
          ...extra.data,
          type: extra.type,
          root: extra.root,
        }
        extra = JSON.stringify(extra)
        IM.getInstance().sendMsg({
          to: options.to,
          extra,
          createtime: t
        }, 'route');
        let unsend = cloneDeep(state.unsendMsgs);
        let unsendItem = {
          type: "custom",
          text: 'route',
          content: 'route',
          createtime: t,
          unsend: true,
          flow: "out",
          status: "sending",
          custom: JSON.stringify({
            messageType: 'ROUTE',
            createtime: t,
            extra,
          }),
          origin: {
            options,
            sendData,
          },
          time: t,
        }
        unsend[options.to] = unsend[options.to] ? [...cloneDeep(unsend[options.to]), unsendItem] : [unsendItem]
        commit('SET_UNSENDMSGS', unsend);
        dispatch('unsendCountdown', {
          unsendInfo: unsendItem,
          to: options.to,
        })
      }, 
      resendCustomMsg({ state, commit, dispatch }, { to, ...args }) {
        IM.getInstance().sendMsg({
          to: to,
          customMsgs: JSON.parse(args.custom).extra,
          createtime: args.time
        }, 'route');
        let unsend = cloneDeep(state.unsendMsgs);
        unsend[to] = unsend[to] ? [...cloneDeep(unsend[to]), { ...args }] : [{ ...args }] 
        commit('SET_UNSENDMSGS', unsend);
        dispatch('unsendCountdown', {
          unsendInfo: { ...args },
          to,
        })
      },
      unsendCountdown({ state, commit }, { unsendInfo, to }) {
        let countdown = setTimeout(() => {
          let unsend = cloneDeep(state.unsendMsgs)
          let ind = (unsend[to] || []).findIndex(unsend => unsend.createtime === unsendInfo.createtime)
          if (unsend[to][ind]) unsend[to][ind].status = 'fail'
          commit("SET_UNSENDMSGS", unsend)
        }, 120000)
        commit("SET_COUNTDOWN", {
          to,
          countdown,
          createtime: unsendInfo.createtime
        })
      },
      removeUnsendMsgs({ state, commit }, data) {
        const to = data.to;
        const msgs = data.list;
        let unsendMsgs = cloneDeep(state.unsendMsgs);
        if (unsendMsgs[to] && unsendMsgs[to].length) {
          msgs.forEach(item => {
            let ind = unsendMsgs[to].findIndex(i => i.time == msgs[0].time && msgs[0].status == 'fail')
            if (ind !== -1) {
              unsendMsgs[to].splice(ind, 1);
            }
          })
        } else {
          unsendMsgs[to] = [];
        }
        commit("SET_UNSENDMSGS", unsendMsgs);
      },
      updateRemoveUnsendMsgs({ state, commit }, data) {
        const to = data.to;
        const msgs = data.list;
        let unsendMsgs = cloneDeep(state.unsendMsgs);
        if (unsendMsgs[to] && unsendMsgs[to].length) {
          msgs.forEach(item => {
            let ind = unsendMsgs[to].findIndex(i => (item.custom || '').includes('createtime') &&  i.createtime === JSON.parse(item.custom).createtime);
            if (ind !== -1) {
              unsendMsgs[to].splice(ind, 1);
            }
          })
        } else {
          unsendMsgs[to] = [];
        }
        commit("SET_UNSENDMSGS", unsendMsgs);
      },
      messageSendError({ state, commit }, data) {
        const to = data.to,
          createtime = data.createtime;
        let unsendMsgs = cloneDeep(state.unsendMsgs);
        if (unsendMsgs[to] && unsendMsgs[to].length) {
          let ind = unsendMsgs[to].findIndex(item => item.createtime === createtime);
          if (ind !== -1) {
            unsendMsgs[to][ind].status = 'fail';
          }
        } else {
          unsendMsgs[to] = [];
        }
        commit("SET_UNSENDMSGS", unsendMsgs);
        commit("SET_COUNTDOWNREMOVE", {
          createtime,
          to
        });
      },
      msgUpdated({ state, commit, dispatch, getters }, { msgMap, to }) {
        if (getters.sessionsMap[to] && getters.sessionsMap[to].id && state.currentSession === to) IM.getInstance().resetSessionUnread(getters.sessionsMap[to].id);
        commit('SET_MSGMAP', msgMap)
        if (!state.unsendMsgs[to]) return
        dispatch('updateRemoveUnsendMsgs', {
          to,
          list: msgMap[to] || [],
        })
      },
      previousPage(_, id) {
        return IM.getInstance().getHistoryMsgs(id);
      },
      
      onmsg({ dispatch, getters, state }, msg) {
        if(msg.type === 'notification' && ['removeTeamMembers', 'leaveTeam', "addTeamMembers"].includes(msg.attach.type)) return
        let notificationMsg = ''
        if(filterRemove(msg)) {
          notificationMsg = '[System]'
        }else {
          switch(msg.type) {
            case 'image':
              notificationMsg = '[Image]'
              break
            case 'audio':
              notificationMsg = '[Voice]'
              break
            case 'custom':
              notificationMsg = '[Route]'
              break
            case 'notification': 
              notificationMsg = '[System]'
              break
            default:
              notificationMsg = msg.text
              break
          }
        }
        if(state.currentSession) return
        if (!getters.singleMap[msg.from] && !getters.teamsMap[msg.from]) return;
        
        Vue.prototype.$tpNotification({
          title: msg.scene === 'team' ? state.teamsList.filter(item => item.tid == msg.target)[0].name : getSingleName(getters.singleMap, msg.from),
          type: msg.scene === 'team' ? 'group' : 'single',
          avatar: msg.scene === 'team' ? getters.teamsMap[msg.to].avatar : getters.singleMap[msg.from].avatar,
          message: notificationMsg,
          showBtn: false,
          showIcon: true,
          showClose: true,
          account: msg.fromNick,
          onClick: async () => {
            await dispatch('setCurrentSession', msg.scene === 'team' ? msg.to : msg.from)
            await dispatch('setPutChat', false);
            let domid = document.querySelector('#a' + msg.time);
            domid.scrollIntoView();
          },
        })
      },
      /**
       * 弹出聊天弹窗
       * @param {*} param0 
       * @param {show, account, drag, (bottom || top, right || left)} payload 接收account，是否展示(默认展示)，位置和是否可拖拽，位置默认距离右下10像素
       */
       showChatbox({ state, commit, dispatch }, payload) {
        if (payload.account) {
          if (typeof payload.account === 'string'){
            payload.account = payload.account.replace('fleet_', '');
          }
          let find = state.singleList.find(i => i.tpUserId == payload.account || i.clientUserId == payload.account || i.accId == payload.account)
          if (find) dispatch('setCurrentSession', find.accId);
        }
        if (!state.currentSession && !payload.account) return;

        let obj = {};
        if (payload.right) {
          obj.right = payload.right;
        }
        if (payload.bottom) {
          obj.bottom = payload.bottom;
        }
        if (payload.left) {
          delete obj.right;
          obj.left = payload.left;
        }
        if (payload.top) {
          delete obj.bottom;
          obj.top = payload.top;
        }
        commit('SET_DRAGCHATBOX', {
          drag: payload.drag ? true : payload.drag === false ? false : true,
          show: payload.show ? true : payload.show === false ? false : true,
          ...obj
        });
      },
      setCurrentAudioData({ state, commit }, data) {
        commit('SET_ALLAUDIO', data)
      }
    },
    
    getters: {
      ...single.getters,
      ...teams.getters,
      sessionsMap(state) {
        const sessionsMap = {}
        state.sessionList.forEach(session => {
          sessionsMap[session.to] = session
        })
        return sessionsMap || {}
      },
      sessionsUnread(state, ...res) {
        if(state.sessionList.length) {
          const filterNotification = state.sessionList.filter(item => item.lastMsg.type !== 'notification')
          const teamList = filterNotification.filter(item => {
            if(item.scene == 'team') return item
          })
          const p2pList = filterNotification.filter(item => {
            if(item.scene == 'p2p') return item
          })
          const contactList = [...checkArray(teamList, state.teamsList), ...p2pList]
          return contactList.some(item => item.unread > 0) ? 1 : 0
        }
        return 0
      },
      isConnectImChat(state) {
        return (email) => {
          if(!email) return false 
          return state.singleList.some(item => item.email == email && item.accId)
        }
      }
    },
  };

  store.registerModule(["im"], state);
  // const authInfo = getStorage("IMAuth");
  // if (authInfo) store.dispatch("im/initIMToken", authInfo);
  sharedServicesMgr.register('imService', () => {
    return {
      initIM: () => store.dispatch("im/initIMToken", '')
    }
  })
}


export default {
  initStore,
};
